import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useDeleteStaff } from "@/hooks/staff/use-staff";
import type { Staff } from "@/types/staff/api-types/staff-types";
import { toast } from "sonner";

interface DeleteStaffDialogProps {
  staff: Staff | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DeleteStaffDialog({
  staff,
  open,
  onOpenChange,
}: DeleteStaffDialogProps) {
  const deleteStaff = useDeleteStaff();

  const handleDeleteConfirm = () => {
    if (staff) {
      deleteStaff.mutate(staff.id, {
        onSuccess: () => {
          toast.success(`Staff member "${staff.first_name} ${staff.last_name}" deleted successfully`);
          onOpenChange(false);
        },
        onError: () => {
          toast.error(`Failed to delete staff member "${staff.first_name} ${staff.last_name}"`);
          onOpenChange(false);
        },
      });
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Staff Member</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete "{staff?.first_name} {staff?.last_name}"?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={deleteStaff.isPending}
            className="w-24"
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleDeleteConfirm}
            disabled={deleteStaff.isPending}
            className="w-24"
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}